<!--
 * @Author: LeeHuiXian
 * @version: 
 * @Date: 2020-08-24 15:45:49
 * @LastEditors: LeeHuiXian
 * @LastEditTime: 2020-08-27 18:04:15
 * @FilePath: /goldenSalesMobile/src/views/RegisterSaler/index.vue
 * @Description: 分销员注册界面
-->
<template>
  <div class='page-container'>
    <div class="logo-box">
      <img src="../../assets/common_image/register_logo.png" alt="">
    </div>
    <van-form class="register-form" @submit="onSubmit" :show-error="false">
      <van-field
          v-model="name"
          type="text"
          name="name"
          placeholder="请输入姓名"
          :rules="[{ required: true, message: '请输入姓名' }]"
        />
      <div class="phone-input">
        <van-field
          v-model="phone"
          type="tel"
          name="phone"
          placeholder="请输入有效的手机号"
          :rules="[{ pattern, message: '请输入有效的手机号' }]"
        />
        <verify-code :phone="phone" @onGetSmsCode="onGetSmsCode" />
      </div>
      <van-field
        v-model="authCode"
        type="number"
        name="authCode"
        placeholder="请输入验证码"
        maxlength="6"
        :rules="[{ required: true, message: '请输入验证码' }]"
      />
      <van-button
        round
        block
        color="linear-gradient(to right, #FA9B00, #FBCA39)"
        native-type="submit"
      >
        立即注册
      </van-button>
    </van-form>
    <g-copy-right />
  </div>
</template>

<script>
import VerifyCode from '@/components/VerifyCode/index'
import { getMsCode, register } from '@/api/user'
import { mobileReg } from '@/utils/index'
import { setToken } from '@/utils/auth'

export default {
  components: { VerifyCode },

  data() {
    return {
      name: '',
      phone: '',
      authCode: '',
      pattern: mobileReg,
      headId: this.$route.query.headId, // 团长id
      inviteId: this.$route.query.id // 邀请人id
    }
  },

  created() {
    // 缓存中获取用户的手机号
    const stroageUserPhone = sessionStorage.getItem('userPhone')
    this.phone = stroageUserPhone
  },

  methods: {
    onGetSmsCode() {
      getMsCode({phone: this.phone})
        .then(res => {
          if (res.success) {
            this.$toast('验证码已发送，请注意查收')
          } else {
            this.$toast(res.error)
          }
        })
        .catch(err => {
// console.log(err)
        })
    },
    onSubmit(values) {
      register({
        HeadId: this.headId, // 团长id
        Id:this.inviteId,
        Name: values.name,
        Phone: values.phone,
        SmsCode: values.authCode
      })
        .then(res => {
          // if (res.UserId && res.Token) {
          //   setToken(res.Token)
          //   if (res.IsDistributor) { // 销售员
          //     localStorage.setItem('userRole', 'distributor')
          //   } else { // 消费者
          //     localStorage.setItem('consumerId', res.UserId)
          //     localStorage.setItem('userRole', 'consumer')
          //   }
          //   // 登录成功后跳转，根据场景指定
          //   if (sessionStorage.getItem('pageBeforeLogin') === 'submitOrder') { // 提交订单
          //     this.$router.replace('/submit-order')
          //   } else if (sessionStorage.getItem('pageBeforeLogin') === 'checkMyOrder') { // 查看订单
          //     this.$router.replace('/users-order')
          //   } else {
          //     this.$router.replace('/sales/goods-list')
          //   }
          // }
          localStorage.setItem('userRole', 'distributor')
          this.$router.replace('/sales/goods-list')
        })
        .catch(err => {
// console.log(err)
        })
    }
  }
}
</script>

<style lang='scss' scoped>
  .page-container {
    box-sizing: border-box;
    padding: 0 60px;
    background: $blockBgColor;
    overflow: hidden;

    .logo-box {
      width: 546px;
      height: 108px;
      margin: 118px 0 200px;

      >img {
        width: 100%;
        height: 100%;
      }
    }

    .register-form {
      .phone-input {
        position: relative;

        >.getAuthCode-btn {
          position: absolute;
          right: 0;
          top: 50%;
          margin-top: -22px;
          z-index: 0;
          height:44px;
          font-size:32px;
          font-weight:500;
          color: rgba(251,202,57,1);
          line-height:44px;
          border: none;
        }
      }

      &::v-deep .van-cell {
        margin-top: 30px;
      }

      &::v-deep .van-button {
        font-size: 18px;
        font-weight: 600;
        margin-top: 80px;
        box-shadow:0px 4px 20px 0px rgba(255,200,99,1);
      }
    }

    .copyright {
      bottom: 0;
    }
  }
</style>
